// extracted by mini-css-extract-plugin
export default {"dashboard-research-objectives":"Dashboard_dashboard-research-objectives__ueYvH"};